import { AgenceService } from 'src/app/Service/agence.service';
import { Component, OnInit } from '@angular/core';
import { Global } from 'src/app/Service/global.service';
import { ActivatedRoute, Router } from '@angular/router';
declare var $: any;
@Component({
  selector: 'app-agence-page',
  templateUrl: './agence-page.component.html',
  styleUrls: ['./agence-page.component.scss']
})
export class AgencePageComponent implements OnInit {

  constructor(private global:Global, private service:AgenceService, private router: Router, private route:ActivatedRoute) { }

  ngOnInit(): void {
    this.global.CurentLanguage.subscribe(lg => { 
      this.route.params.subscribe(params => {
        if(params['page'] !== undefined && params['page'] !== '' && params['page'] !== null) {
          this.service.getMenuData().subscribe(datas => {
            let exist = false;
            let dynamique = false;
            datas['value'].forEach(element => {
              if(element.MenuUrl.toLowerCase() === params['page'].toLowerCase()) {
                exist = true;
                if(element.PageDynamique) {
                  dynamique = true;
                }
              }
          
            });
            if(exist && !dynamique) {
              this.service.getMenuPageData(params['page'], lg.code).subscribe( contents => {
                const url = this.global._baseUrlRacine + contents['value'][0].File.ServerRelativeUrl;
                $('#content').load(url,()=>{
                  $('#content style').remove();
                });
              })
            } else if(exist && dynamique) {
            //  this.router.navigate([ params['page']]);
            
            } else {
              alert('Page Inexistante'); 
              this.router.navigate(['/']);
            }
          })
        }
      })

      
    });
  }

}
